import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { withNamespaces, Trans } from 'react-i18next';
import Alert from 'react-s-alert';
import InputFile from 'components/InputFile';

import { InputFileMainWrapper } from 'apps/repository/views/cwdDropzone.styles';

class DropzoneState {
  @observable draggingFile = false;
  @action SetDragging = bool => {
    this.draggingFile = bool;
  };
}

@withNamespaces()
@observer
export class CwdDropzone extends React.Component {
  UNSAFE_componentWillMount() {
    this.dropzoneState = new DropzoneState();
  }

  handleFileDrop(list) {
    const listWithoutFolders = list.filter(f => f.size !== 0 && f.type !== '');

    if (list.length !== listWithoutFolders.length) {
      Alert.error(
        'Please, use the Upload folder button for adding folders and their contents',
      );
    }
    if (listWithoutFolders.length > 0) {
      this.props.addFiles(listWithoutFolders);
    }

    this.dropzoneState.SetDragging(false);
  }

  render() {
    const { visible, handleDragLeave } = this.props;
    const { SetDragging } = this.dropzoneState;

    if (visible) {
      return (
        <InputFileMainWrapper>
          <InputFile
            multiple
            iconName='upload'
            message={
              <Trans>
                Drop your files here for adding them or replacing the old
                versions. <br></br>You can also use the Upload folder button for
                adding full folders to the project.
              </Trans>
            }
            setOnDragEnter={() => SetDragging(true)}
            setOnDragLeave={() => {
              SetDragging(false);
              if (handleDragLeave) handleDragLeave();
            }}
            setOnChange={list => this.handleFileDrop(list)}
          />
        </InputFileMainWrapper>
      );
    }
    return null;
  }
}

CwdDropzone.propTypes = {
  visible: PropTypes.bool,
  handleDragLeave: PropTypes.func,
  addFiles: PropTypes.func,
  rejectFiles: PropTypes.func,
};
